import React from "react"
import Office from "../../components/pages/development/office"

const OfficePage = (props) => <Office {...props} />

export default OfficePage